// var BASE_URL = 'https://currencyconverter.skypad.biz'
// var BASE_URL = 'http://192.168.100.220:5001' //APP SERVER(220)
// var BASE_URL = 'http://localhost:3000' //local computer

let BASE_URL = window.location.origin;

if (window.location.hostname === "localhost") {

 BASE_URL = "http://localhost:5002/";

}

export const AUTH_CONFIG = {
  // TEST: login-hub1.skypad.biz  |  PROD: login-hub.skypad.biz (swap at prod deploy)
  domain: 'login-hub.skypad.biz',
  // TEST: QWj9yVt0PvcIowpGMnXayNuX95RKiRce  |  PROD: chKH3mamm6VwO6EAV07VwcKrgN6a4fDG (swap at prod deploy)
  clientId: 'chKH3mamm6VwO6EAV07VwcKrgN6a4fDG',
  callbackUrl: window.location.origin,
  baseUrl: BASE_URL,
  // TEST: omit  |  PROD: LDAP-Connection-GCP (swap at prod deploy)
  basicConnection: 'LDAP-Connection-GCP',
  // Fallback SSO tenant config. Live values are loaded from the server
  // (MongoDB sso-access-dev / sso-access) at startup by ssoConnectionsLoader.js,
  // which replaces this object in place. These literals are used only until that
  // fetch resolves, or if it fails / returns empty.
  ssoConnections: {
    giii: {
      displayName: 'G-III',
      aliases: ['g-iii', 'giii', 'g-iii.com'],
      domains: ['g-iii.com'],
      users: [],
      allowAllUsers: true,
      connection: 'giii-sso',
      organization: undefined,
    },
    acneStudios: {
      displayName: 'Acne Studios',
      aliases: ['acne-studios', 'acnestudios', 'acnestudios.com'],
      domains: ['acnestudios.com'],
      users: [],
      allowAllUsers: true,
      connection: 'Acne-studios-sso',
      organization: undefined,
    },
  },
}
